export const PRODUCTION_API = "https://api.michelbandalidesign.com";

/** Runtime: localhost uses CRA proxy; live site always uses API subdomain */
export function getApiBaseUrl() {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "";
    }
  }
  return PRODUCTION_API;
}

export function apiUrl(path) {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalized}`;
}
